// extracted by mini-css-extract-plugin
export default {"button":"StylePrimarySmallFalseDa_button__8yhXm","styleprimarySmallfalseDa":"StylePrimarySmallFalseDa_styleprimarySmallfalseDa__I--Zx"};